import RotateObjectActionMetadata from 'automation-ui-action-features/actions/rotate-object/RotateObjectActionMetadata';
import { ROUTING_ROTATE_TICKET_OWNER } from 'automation-ui-action-features/constants/Gates';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { TICKET_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { UnifiedRoutingActionDetail } from 'automation-ui-action-features/actions/rotate-object/UnifiedRoutingActionDetail';
import { UnifiedRoutingActionPreview } from 'automation-ui-action-features/actions/rotate-object/UnifiedRoutingActionPreview';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const RotateObjectActionDetailPropType = {
  actionMetadata: PropTypes.instanceOf(RotateObjectActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType,
  messageLangPath: PropTypes.string
};
const RotateObjectActionDetail = ({
  actionMetadata,
  flowObjectTypeId,
  messageLangPath = 'actionDetail'
}) => {
  const isUngatedToSVHTicketRouting = useIsUngated(ROUTING_ROTATE_TICKET_OWNER);
  if (!flowObjectTypeId) {
    return null;
  }
  if (flowObjectTypeId === TICKET_ID && isUngatedToSVHTicketRouting) {
    return messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(UnifiedRoutingActionDetail, {
      actionMetadata: actionMetadata,
      objectTypeId: flowObjectTypeId
    }) : /*#__PURE__*/_jsx(UnifiedRoutingActionPreview, {
      actionMetadata: actionMetadata,
      objectTypeId: flowObjectTypeId
    });
  }
  const teamIds = actionMetadata.teamIds || [];
  const userIds = actionMetadata.userIds || [];
  if (messageLangPath === 'actionDetail') {
    return teamIds.length ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-action-features.action-features.rotate-object.action-detail.between-teams_cob",
      objectTypeId: flowObjectTypeId,
      options: {
        count: teamIds.length
      }
    }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-action-features.action-features.rotate-object.action-detail.between-users_cob",
      objectTypeId: flowObjectTypeId,
      options: {
        count: userIds.length
      }
    });
  } else {
    return teamIds.length ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-action-features.action-features.rotate-object.action-preview.between-teams_cob",
      objectTypeId: flowObjectTypeId,
      options: {
        count: teamIds.length
      }
    }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-action-features.action-features.rotate-object.action-preview.between-users_cob",
      objectTypeId: flowObjectTypeId,
      options: {
        count: userIds.length
      }
    });
  }
};
RotateObjectActionDetail.propTypes = RotateObjectActionDetailPropType;
export default RotateObjectActionDetail;